import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { TierAction, useTierProvider } from '../Tier.Hooks';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function TierList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useTierProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.tiers}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.orderNumber}</th>
          <th>{lang.name}</th>
          <th>{lang.vehicleMakes}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: tier }) => (
            <tr key={tier.id}>
              <td>{tier.orderNumber ? `#${tier.orderNumber}` : 'N/A'}</td>
              <td>{tier.name}</td>
              <td>{tier.vehicleMakes?.map((it) => it.makeCode)?.join(', ')}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: tier.id.toString(),
                      action: TierAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_PRODUCT}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: tier.id.toString(),
                      action: TierAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_PRODUCT}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
